// src/services/DataStore.js
export default class DataStore {
  constructor() {
    this.data = null;
    this.myListFlag = true;
  }

  // Metode za data
  setData(data) {
    this.data = data;
  }

  getData() {
    return this.data;
  }

  clearData() {
    this.data = null;
  }

  // Metode za myList flag
  setMyListFlag(flag) {
    this.myListFlag = flag;
  }

  getMyListFlag() {
    return this.myListFlag;
  }

  clearMyListFlag() {
    this.myListFlag = false;
  }
}

const store = new DataStore();
export { store };
